export const cleanPhone = (number) => {
  // Clean one phone number
  var temp = number;
  if (temp) {
    if (typeof temp === typeof 1) {
      temp = temp.toString();
    }
    if (temp?.length > 20) {
      return temp;
    }
    temp = temp.replaceAll(" ", "");
    temp = temp.replaceAll("+", "");
    temp = temp.replaceAll("'", "");
    temp = temp.replaceAll("(", "");
    temp = temp.replaceAll(")", "");
    temp = temp.replaceAll("-", "");
    temp = temp.replaceAll(".", "");
    if (temp.slice(0, 2) === "00") {
      temp = temp.slice(2);
    }
    if (temp.slice(0, 3) === "330") {
      temp = "33" + temp.slice(3);
    }
    if (temp.slice(0, 1) === "0") {
      temp = "33" + temp.slice(1);
    }
  }
  return temp;
};
